import React from 'react';
import './deadlines.css';
import { useTranslation } from 'react-i18next';

function Deadlines() {
  const { t } = useTranslation();
  return (
    <div className="deadlines">
      <li>
        <a href="google.com">{t('services-deadline-deadline')}</a>
      </li>
      .
      <li>
        <a href="google.com">{t('services-deadline-Calculator')}</a>
      </li>
    </div>
  );
}
export default Deadlines;
